import './author.scss';
import Header from './../../src-utilities/header';
import './../../src-utilities/footer';
import './../../src-utilities/country';
import Swiper from './../../../node_modules/swiper';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import JustValidate from '.././../../node_modules/just-validate';

new Header();

const initSwiperWhenVisible = (selector, options) => {
	const el = document.querySelector(selector);
	if (!el) return;

	const observer = new IntersectionObserver(
		(entries, obs) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					new Swiper(selector, options);
					obs.unobserve(entry.target);
				}
			});
		},
		{ rootMargin: '200px' },
	);

	observer.observe(el);
};

document.addEventListener('DOMContentLoaded', () => {
	const filterTabs = document.querySelectorAll(
		'.articles-filter-tabs .tab-btn',
	);
	const articleCards = document.querySelectorAll(
		'.author-articles-slider .article-card',
	);

	if (filterTabs.length > 0) {
		filterTabs.forEach((tab) => {
			tab.addEventListener('click', () => {
				filterTabs.forEach((t) => t.classList.remove('active'));
				tab.classList.add('active');

				const selectedCategory = tab.getAttribute('data-category');

				articleCards.forEach((card) => {
					const cardCategory = card.getAttribute('data-category');
					if (
						selectedCategory === 'all' ||
						cardCategory === selectedCategory
					) {
						card.style.display = 'flex';
					} else {
						card.style.display = 'none';
					}
				});
			});
		});
	}

	new Swiper('.swiper-container', {
		modules: [Pagination, Autoplay],
		slidesPerView: 1,
		loop: true,
		// autoplay: {
		// 	delay: 2000,
		// 	pauseOnMouseEnter: true,
		// 	disableOnInteraction: false,
		// },
		breakpoints: {
			360: {
				spaceBetween: 15,
				slidesPerView: 1,
			},
			500: {
				spaceBetween: 15,
				slidesPerView: 1,
			},
			600: {
				slidesPerView: 2,
				spaceBetween: 30,
			},
			1100: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
		},
	});

	initSwiperWhenVisible('.deep-dive-section-slider', {
		modules: [Autoplay, Navigation],
		loop: true,
		autoplay: {
			delay: 2000,
		},
		slidesPerView: 3,
		spaceBetween: 100,
		navigation: {
			nextEl: '.deep-dive-section .swiper-button-next',
			prevEl: '.deep-dive-section .swiper-button-prev',
		},
		breakpoints: {
			320: {
				slidesPerView: 1,
				spaceBetween: 100,
			},
			600: {
				slidesPerView: 2,
				spaceBetween: 40,
			},
			1000: {
				slidesPerView: 3,
				spaceBetween: 60,
			},
			1200: {
				slidesPerView: 3,
				spaceBetween: 100,
			},
		},
	});
});

// Subscribe CTA Form
const subValidate = new JustValidate('#cta-subscribe-form');

subValidate.addField('#success-companyemail-cta', [
	{
		rule: 'required',
	},
	{
		rule: 'email',
	},
	{
		validator: (value) => {
			let emailRegex =
				/^[a-zA-Z0-9](?:[a-zA-Z0-9._-]*[a-zA-Z0-9])?@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,7})+$/;
			return emailRegex.test(value);
		},
		errorMessage: 'Please Enter Valid Email Address',
	},
]);

//#region Start CTA Subscribe Form

let Googlesubscribe_SendURL =
	'https://script.google.com/macros/s/AKfycbyML8OHUDSwwvY_QcBlZ2uHYN_rQIx_VlWZPLjpxoJ9dB8GQEr6J7U0D8kNzC3-p0nH/exec';

var loading_global_subscribe = document.querySelector('.loading-div');

document
	.querySelector('#cta-subscribe-form')
	.addEventListener('submit', async (event) => {
		event.preventDefault();
		if (subValidate.isValid == false) {
			return false;
		} else {
			console.log(subValidate.isValid);
		}

		loading_global_subscribe.classList.add('active');

		let formData = new FormData(event.target);
		formData.append('sendurlvalue', window.location.href);
		formData.append('lsource', 'SS-News-Letter-Form-CTA');

		let myHeaders = new Headers();
		myHeaders.append('Content-Type', 'application/json');

		// Initiate the Sales IQ visitor data
		if (window.$zoho && window.$zoho.salesiq) {
			try {
				$zoho.salesiq.visitor.uniqueid();
				$zoho.salesiq.visitor.name(firstName + ' ' + lastName);
				$zoho.salesiq.visitor.email(formData.get('lemail'));
				console.log('SalesIQ Name/Email set');
			} catch (error) {
				console.warn('SalesIQ Error:', error);
			}
		}

		let raw = JSON.stringify({
			email: formData.get('lemail'),
			leadSource: formData.get('lsource'),
			websiteVisitURL: window.location.href,
		});

		let requestOptions = {
			method: 'POST',
			headers: myHeaders,
			body: raw,
			redirect: 'follow',
		};
		let googleRequestOptions = {
			method: 'GET',
			redirect: 'follow',
		};
		let request = '?';
		[...formData].forEach(([key, value], index) => {
			request += `${index === 0 ? '' : '&'}${key + '=' + value}`;
		});

		// Request 1: Main Backend
		const backendRequest = fetch(
			'https://us-west1-zoho-crm-scripts.cloudfunctions.net/queueLeadHttp',
			requestOptions,
		);
		// Request 2: Update the Google Sheet Data
		const googleRequest = fetch(
			Googlesubscribe_SendURL + request,
			googleRequestOptions,
		);
		// Waiting until these request get's completed
		try {
			await Promise.allSettled([backendRequest, googleRequest]);
		} catch (e) {
			console.error('API Error', e);
		}
		// Redirect
		window.location.href = 'https://cyntexa.com/success?msg=newsletter';
	});

//#endregion Start CTA Subscribe Form
